<div class="container">
  <swiper-container class="h-full w-full" #swiperSlideRef [init]="false">
    <swiper-slide *ngFor="let slide of sliders">
      <div class="h-full w-full" [ngClass]="{ pointer: slide.url }" (click)="goToUrl(slide)">
        <img class="h-full w-full" [src]="slide.image" [title]="slide.title" />
      </div>
    </swiper-slide>
  </swiper-container>
</div>
